import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import Modal from "../../common/Modal";
import AddUpdate from "./addUpdate";
import SingleStatusToggle from "../../common/singleStatusToggle";
import ReactTooltip from "react-tooltip";
import Icon from "../../icons/index";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CS from "../../../services/commonService";
import React, { useState, useEffect, useCallback } from "react";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import { useGetMoods, useUpdateMood } from "../../../queryHooks";

//	Pre-defined values
const columnKey = "moods";
//	Component starts
const Moods = () => {
	//	State values
	const setLoading = useStore((state) => state.setLoading);
	const [moodData, setMoodData] = useState({});
	const [open, setOpen] = useState(false);
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	//refetchMoods
	const [payload, setPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		sort: { created_at: "DESC" },
	});

	/******************************************************************************************
	@Purpose    :   To get the categories list
	*******************************************************************************************/

	const {
		data: dataMoods,
		isLoading,
		refetch: refetchMoods,
	} = useGetMoods(qs.stringify(payload));

	useEffect(() => {
		if (dataMoods) {
			setLoading(false);
			if (dataMoods.status === "success") {
				let respData = dataMoods.data;
				respData.page = pageNow;
				respData.items_per_page = itemsPerPage;
				setTableData(respData);
			}
		}
	}, [dataMoods]);

	/******************
	 * update status
	 */

	const handleChangeStatus = (id, status) => {
		setLoading(true);
		const body = { is_active: status };
		const obj = {
			moodId: id,
			body,
		};
		updateMoodAsync(obj);
	};

	const {
		mutateAsync: updateMoodAsync,
		error: errorUpdateMood,
		data: dataUpdateMood,
	} = useUpdateMood();

	useEffect(() => {
		if (dataUpdateMood) {
			setLoading(false);
			if (dataUpdateMood.status === "success") {
				refetchMoods();
				CS.showSuccessMessage(dataUpdateMood.message);
			} else if (dataUpdateMood.status === "fail") {
				CS.showErrorMessage(dataUpdateMood.message);
			}
		}
	}, [dataUpdateMood]);

	useEffect(() => {
		if (errorUpdateMood) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateMood.response?.data?.message);
		}
	}, [errorUpdateMood]);

	/******************************************************************************************
	@Purpose    :   To close the modal
	*******************************************************************************************/
	const closeModal = useCallback(
		(reload) => {
			setOpen(false);
			setMoodData({});
			if (reload === true) refetchMoods();
		},
		[refetchMoods]
	);

	/*************************************
	 *
	 * columns
	 **********************************/
	const columns = [
		{
			label: "Label",
			type: "string",
			sort: true,
			alias: "label",
			path: "label",
		},
		{
			label: "Emoji",
			type: "string",
			alias: "emoji",
			path: "emoji",
			content: (item) => (
				<span className="pl-2" style={{ fontSize: 25 }}>
					{item?.emoji}
				</span>
			),
		},
		{
			label: "Created On",
			type: "string",
			sort: true,
			alias: "created_at",
			path: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item?.created_at, true),
		},
		{
			label: "Status",
			type: "string",
			aliasFilter: "is_active",
			filterOptions: [
				{ value: 1, label: "Active" },
				{ value: 0, label: "Inactive" },
			],
			content: (item) => (
				<SingleStatusToggle
					_id={item?.id}
					status={item?.is_active == 1 ? true : false}
					onToggleChange={() =>
						handleChangeStatus([item?.id], !item?.is_active)
					}
					htmlFor={item?.id}
				/>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setLoading(false);
							setOpen(true);
							setMoodData(item);
						}}
					/>
					<ReactTooltip id="edit">Edit</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<BreadCrumbs title="Master Management" data={[{ label: "Moods" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setPayload({
														...payload,
														search: {
															label: !value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => setOpen(true)}
												id="addNewMood"
												type="button"
												className="btn glow-primary btn-primary"
											>
												<i className="bx bx-user-plus d-lg-none" />
												<span className="d-none d-sm-none d-lg-inline-block">
													Add New Mood
												</span>
											</button>
											{/* <Download columnKey={columnKey} /> */}
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={closeModal}>
								<AddUpdate
									moodData={moodData}
									columnKey={columnKey}
									onCloseModal={closeModal}
									refetchMoods={refetchMoods}
								/>
							</Modal>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								payload={payload}
								sortCol={(obj) => {
									setPageNow(1);
									setPayload({
										...payload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setPayload({ ...payload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setPayload({
										...payload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(payload.filter, obj);
										setPageNow(1);
										setPayload({
											...payload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setPayload({
											...payload,
											filter: {
												...payload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setPayload({
										...payload,
										filter_date: dates && {
											...payload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Moods;
